<script lang="ts">
  import { cn } from '@shared/utils';

  export let containerClass = '';
</script>

<section class="{cn('mx-auto px-5 md:px-8 xl:px-12', containerClass)}">
  <slot />
</section>
